import { z } from 'zod'

import { AbTestSlice } from '../types'

export const schema = z.object({
  id: z.string(),
  variantName: z.string(),
})

export const schemaDefaults = (abTest: AbTestSlice): Schema => ({
  id: abTest.id,
  variantName: '',
})

export type Schema = z.infer<typeof schema>
